import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import "./SafeLocationAlerts.css";

const SafeLocationAlertsList = ({ ...props }) => {

  const dateFormatter = (cell, row) => {
    return `${moment(row.eventTimestamp).format("MM/DD/YYYY")}   ${moment(
      row.eventTimestamp
    ).format("hh:mm A")}`;
  };

  const srNumberFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (props.currentPage > 1)
      return <>{props.perPage * (props.currentPage - 1) + (rowIndex + 1)}</>;
    else return <>{rowIndex + 1}</>;
  };

  const alertTypeFormatter = (cell, row) => {
    return row.fenceAlertType === "IN_FENCE" ? "When entering the specified location" : "When outside the specified location";
  };

  const contactsFormatter = (cell, row) => {
    if (row.alertContacts.length > 0) {
    return  row.alertContacts.map((val) => {
        return <div>
          {`${val.firstName} ${val.lastName} [${val.phoneNumber}]`}
        </div>
      })
    } else return "";
  };

  const columns = [
    {
      dataField: "id",
      text: "No.",
      formatter: srNumberFormatter,
      headerStyle: () => {
        return { width: "65px" };
      },
    },
    {
      dataField: "eventTimestamp",
      text: "EVENT DATE/TIME ",
      formatter: dateFormatter,
    },
    {
      dataField: "fenceAlertType",
      text: "ALERT TYPE",
      formatter: alertTypeFormatter
    },
    {
      dataField: "safeLocation.locationName",
      text: "SAFE LOCATION NAME",
    },
    {
      dataField: "address",
      text: "ADDRESS",
    },
    {
      dataField: "alertContacts",
      text: "CONTACT'S ALERTED",
      formatter: contactsFormatter
    },
  ];
  const defaultSorted = [
    {
      dataField: "reportedAt",
      order: "desc",
    },
  ];


  return (
    <BootstrapTable
      keyField="id"
      wrapperClasses="drilldown-list-table-wrapper"
      classes="drilldown-list-table"
      data={props.safeLocationAlertsList.sort((t1, t2) => {
        if (t1.eventTimestamp > t2.eventTimestamp) return -1;
        if (t1.eventTimestamp < t2.eventTimestamp) return 1;
        return 0;
      })}
      columns={columns}
      striped
      hover
      condensed
      bordered={false}
      defaultSorted={defaultSorted}
      noDataIndication="No safe location alerts found for the selected date range."
    />
  );
};

export default SafeLocationAlertsList;
